import React, { FunctionComponent } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

interface IProps {
  label: string;
  description?: string | null;
  required?: boolean;
  iconUrl?: string;
}

const FormLabel: FunctionComponent<IProps> = ({ label, description = "", required = false, iconUrl = null }) => (
  <span className="text-neutral-12 flex gap-1 md:gap-2">
    {iconUrl && <img src={iconUrl} alt="icon" className="w-6 h-6 object-cover inline-block" />}
    <span>
      {label}
      {/* leading-none: the larger star must not grow the label's line, or a required field sits lower than an optional one beside it. */}
      {required && <span className="text-[#FF3B3B] ml-1 text-xl font-semibold leading-none">*</span>}
      {description && (
        <div className="text-sm text-neutral-8 mt-1 font-normal whitespace-normal">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            components={{
              ul: ({ children }) => <ul className="list-disc pl-5 my-0">{children}</ul>,
              ol: ({ children, start }) => (
                <ol start={start} className="list-decimal pl-5 my-0">
                  {children}
                </ol>
              ),
              li: ({ children }) => <li className="mb-1 last:mb-0">{children}</li>,
              p: ({ children }) => <p className="mb-1 last:mb-0">{children}</p>,
              strong: ({ children }) => <strong className="font-semibold">{children}</strong>
            }}
          >
            {description}
          </ReactMarkdown>
        </div>
      )}
    </span>
  </span>
);

export default FormLabel;
